import './ConfidenceScoreModal.scss';

import React, { useState } from 'react';
import BaseModal from 'components/shared/Modal/BaseModal';
import Content from 'services/Content';

const ConfidenceScoreModal = () => {
  const [isOpen, setOpen] = useState(false);

  return (
    <div className="confidence-score-modal">
      <BaseModal
        title="Important Information"
        linkContent="Important Information"
        linkContentClass="important-information-modal-text"
        closeTitle={null}
        // renderModalContent={<div content={ Content.confidenceScoreModalCopy}/>}>
        open={() => setOpen(true)}
        close={() => setOpen(false)}
        isOpen={isOpen}
        disableFixed
        hideIcon>
        <div className="confidence-score-modal-copy">
          {Content.confidenceScoreModalCopy}
        </div>
      </BaseModal>
    </div>
  );
};

export default ConfidenceScoreModal;
